module.exports = __webpack_public_path__ + "img/spirit_shard.ccb573ed.png";